<template>
  <v-card class="dash_main_banner_card" elevation="0">
    <v-row>
      <v-col>
        <h2 class="mb-3"> 스트림온 비디오 CMS</h2>
        <v-row>
          <v-col style="line-height: 30px;">
            스트림온은 VOD와 라이브 서비스 및 동영상 컨텐츠 관리를 위해<br>
            미디어서버, 인코더, 스토리지, CDN이 통합된 솔루션 입니다.
          </v-col>
        </v-row>

        <v-row>
          <v-col style="color: #0066cc;font-weight: bold;">
            <router-link to="/vod-manual" target="_blank">
              <v-chip link label color="#eee" style="color: #0066cc;">
                VOD 사용법
              </v-chip>
            </router-link>
            <!-- <router-link to="/live-manual">
              <v-chip class="ml-2" link label color="#eee" style="color: #0066cc;">
                LIVE 사용법
              </v-chip>
            </router-link> -->
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pa-0 mt-4">
        <v-img src="../../styles/dashboard/dash_images.png" width="300" style="margin-left: auto;"></v-img>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "DashboardHeader",

}
</script>

<style lang="scss" scoped></style>